import { track } from '@eventbrite/datalayer-library';
import {
    CREATOR_CATEGORY_HEAP_NAMES,
    MUSIC_CREATOR_CATEGORY_HEAP_NAMES,
    SALES_OPTIONS_HEAP_NAMES,
    VISITORS_OPTIONS_HEAP_NAMES,
} from '../config/constants';
import { Answers } from '../storage/types';

export const trackOnboardingAnswers = (answers: Answers) => {
    if (!answers || Object.entries(answers)?.length === 0) return null;

    const onboardingEventFrequencyAnswerHeapName =
        SALES_OPTIONS_HEAP_NAMES[answers?.events_volume_pp?.[0]?.name];

    const onboardingEventSizeAnswerHeapName =
        VISITORS_OPTIONS_HEAP_NAMES[answers?.event_attendees_pp?.[0]?.name];

    const eventCategoryAnswerHeapName =
        CREATOR_CATEGORY_HEAP_NAMES[
            answers?.event_category?.[0]?.name.toUpperCase()
        ];
    const eventVerticalAnswerHeapName =
        MUSIC_CREATOR_CATEGORY_HEAP_NAMES[
            answers?.event_vertical?.[0]?.name.toUpperCase()
        ];

    const heapData = {
        eventType: eventCategoryAnswerHeapName,
        organizationType: eventVerticalAnswerHeapName,
        eventFrequency: onboardingEventFrequencyAnswerHeapName,
        eventSize: onboardingEventSizeAnswerHeapName,
    };

    track({
        eventName: 'LoggedOutCreatorOnboardingResponsesSaved',
        eventData: { ...heapData },
    });
};
